export var arrayToObject = function arrayToObject(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return array.reduce(function (obj, item) {
    obj[item[key]] = item;
    return obj;
  }, {});
};
/**
 * Returns array of ids in the same order as the input array
 * of objects
 */

export var arrayOfObjectsOrder = function arrayOfObjectsOrder(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id'; // TODO: Check return type.

  var order = [];

  for (var i = 0; i < array.length; i++) {
    order.push(array[i][key]);
  }

  return order;
};
export var normaliseArrayOfObjects = function normaliseArrayOfObjects(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return {
    byId: arrayToObject(array, key),
    order: arrayOfObjectsOrder(array, key)
  };
};
export var getAuthToken = function getAuthToken() {
  return document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, '$1');
};
export var saveToCookie = function saveToCookie(token) {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'token=' + token + ';domain=.roymorgandev.com;path=/';

    case 'uat':
      document.cookie = 'token=' + token + ';domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'token=' + token + ';domain=.roymorgan.com;path=/';
      break;

    default:
      document.cookie = 'token=' + token + ';path=/';
      break;
  }
};
export var removeCookie = function removeCookie() {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'token=0;expires=0;domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'token=0;expires=0;domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'token=0;expires=0;domain=.roymorgan.com;path=/';
      break;

    default:
      document.cookie = 'token=0;expires=0;path=/';
      break;
  }
};
export var getProductUrl = function getProductUrl(productFamilyId, env) {
  switch (productFamilyId) {
    case '1':
      // Live Management
      return '/';

    case '2':
      // Audiences
      switch (env) {
        case 'dev':
          return '//audiences.roymorgandev.com';

        case 'uat':
          return '//audiences.roymorganuat.com';

        default:
          return '//audiences.roymorgan.com';
      }

    case '3':
      // Search
      switch (env) {
        case 'dev':
          return '//search.roymorgandev.com';

        case 'uat':
          return '//search.roymorganuat.com';

        default:
          return '//search.roymorgan.com';
      }

    case '4':
      // Live Mapping
      switch (env) {
        case 'prod':
          return '//mapping.roymorgan.com';

        case 'uat':
          return '//livemapping.roymorganuat.com';

        default:
          return '//livemapping.roymorganuat.com';
      }

    case '5':
      // Helix Encoding
      return '/';

    case '6':
      // Helix 2.0
      return '//helix.roymorganuat.com';

    case '-1':
      // Helix 2.0
      return '/no-access';

    default:
      return '/';
  }
};
export var getApiEndpoint = function getApiEndpoint(appEnv) {
  var env = appEnv ? appEnv : 'dev';

  switch (env) {
    case 'prod':
      return 'https://liveapi.roymorgan.com/v1';

    case 'uat':
      return 'https://liveapi.roymorganuat.com/v1';

    default:
      return 'https://liveapi.roymorgandev.com/v1';
  }
};
export var hasProductAccess = function hasProductAccess(products, currentProduct) {
  return products.filter(function (product) {
    return product.hasAccess === true && product.name === currentProduct;
  }).length > 0;
};